import { selfAxios } from "@oppein/op-utils";

/**
 * 查询资料包信息
 * @param params
 * @returns
 */
export async function queryInformationPackList(params = {}) {
  const { data } = await selfAxios.get(
    "/designordercenter/designUnifiedRuleController/queryInformationPackList",
    {
      params,
    },
  );
  return data;
}

/**
 * 查询审单条件
 * @param params
 * @returns
 */
export async function queryReviewConditionList(params = {}) {
  const { data } = await selfAxios.get(
    "/designordercenter/designUnifiedRuleController/queryReviewConditionList",
    {
      params,
    },
  );
  return data;
}

/**
 * 保存或更新资料包信息
 * @param params
 * @returns
 */
export async function saveOrUpdateInformationPackList(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/designUnifiedRuleController/saveOrUpdateInformationPackList",
    params,
  );
  return data;
}

/**
 * 保存或更新审单条件
 * @param params
 * @returns
 */
export async function saveOrUpdateReviewConditionList(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/designUnifiedRuleController/saveOrUpdateReviewConditionList",
    params,
  );
  return data;
}

/**
 * 获取产品渠道
 * @param params
 * @param params
 * @param params.brand  - 品牌
 * @param params.category - 品类
 * @returns
 */
export async function getProductChannelList(params = {}) {
  const { data } = await selfAxios.get(
    "/ucenterapi/uc/internal/dict/getProductChannelList",
    { params },
  );
  return data;
}
/**
 * 获取所属门店列表
 * @param params
 * @param params
 * @param params.brand  - 品牌
 * @param params.category - 品类
 * @returns
 */
export async function getShopListByConToPost(params = {}) {
  const { data } = await selfAxios.post(
    "/ucenterapi/internal/shop/getShopListByConToPost",
    params,
  );
  return data;
}
/**
 * 批量保存资料包附件数据
 * @param params
 * @returns
 */
export async function batchSaveCustomerInformationPackAttachment(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerInformationPackAttachment/batchSaveCustomerInformationPackAttachment",
    params,
  );
  return data;
}

/**
 * 批量保存或修改资料包数据
 * @param params
 * @returns
 */
export async function batchSaveOrUpdateByBusinessType(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerInformationPackAttachment/batchSaveOrUpdateByBusinessType",
    params,
  );
  return data;
}

/**
 * 查询资料包附件列表
 * @param params
 * @returns
 */
export async function customerInformationPackAttachmentGetListByQry(
  params = {},
) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerInformationPackAttachment/getListByQry",
    params,
  );
  return data;
}

/**
 * 删除资料包附件-附件ID
 * @param params
 * @returns
 */
export async function customerInformationPackAttachmentDeleteById(params = {}) {
  const { data } = await selfAxios.get(
    "/designordercenter/customerInformationPackAttachment/deleteById",
    { params },
  );
  return data;
}

/**
 * 根据服务号ID查询当前用户已确认报价结果列表
 * @param params
 * @returns
 */
export async function queryConfirmQuotationResultListByServiceId(params = {}) {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationResultController/queryConfirmQuotationResultListByServiceId",
    params,
  );
  return data;
}

/**
 * 根据报价id获取报价品类列表
 * @param params
 * @returns
 */
export async function queryCategoryListByQuotationIdList(params = {}) {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationResultController/queryCategoryListByQuotationIdList",
    params,
  );
  return data;
}

/**
 * 批量保存或更新子状态
 * @param params
 * @returns
 */
export async function subStatusControllerBatchSaveOrUpdate(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/subStatusController/batchSaveOrUpdate",
    params,
  );
  return data;
}

/**
 * 获取产品渠道
 * @param params
 * @param params
 * @param params.serviceId  - 服务ID
 * @returns { interestCategoryList: Array<String>; orderCategoryList: Array<String> }
 * interestCategoryList 意向品类
 * orderCategoryList 下单品类
 */
export async function queryCategoryByServiceId(params = {}) {
  const { data } = await selfAxios.get(
    "/designordercenter/customer/queryCategoryByServiceId",
    { params },
  );
  return data.data;
}

/**
 * 根据组织编码查询启用的审批配置列表
 * @param {Object} params
 * @param {string} params.orgNo - 组织编号
 * @returns {Array} 合同配置列表
 */
export async function queryContractConfirmConfig(params = {}) {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationEContractAuditController/findEnabledAuditConfigListByOrgNo",
    params,
  );
  return data;
}

/**
 * 保存合同确认配置
 * @param {Object} params
 * @returns
 */
export async function saveContractConfirmConfig(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/contractConfirmConfig/save",
    params,
  );
  return data;
}

/**
 * 创建飞书审批单据
 * @param {Object} params
 * @returns
 */
export async function createFeishuApproval(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/feishuApproval/create",
    params,
  );
  return data;
}

/**
 * 创建mtds审单任务
 * @param {Object} params
 * @returns
 */
export async function createMtdsReviewTask(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/mtdsReviewTask/create",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/reviewOrder/index.js